<template>
    <v-dialog v-model="$props.isActiveDialog">
        <v-card :loading="loading">
            <v-card-title>
                <v-btn icon="arrow-left" @click="$emit('close')" v-if="showBackArrow"></v-btn>
                <v-img src="/logo.png" height="50"></v-img>
                <h2 class="text-center" v-if="formData.title != ''">
                    {{ formData.title }}
                </h2>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-form ref="form" @submit.prevent @keyup="isShowNextButtonDisabled = false">
                    <div class="modal-content">

                        <div v-for="field in formData.fields" :key="field.id">
                            <v-text-field v-if="field.type == 'text'" color="primary" type="text" :label="field.label"
                                :id="field.name" :name="field.name" v-model="field.value" :required="field.required"
                                :rules="field.validation"></v-text-field>
                            <v-text-field v-if="field.type == 'password'" color="primary" type="password"
                                placeholder="******" :label="field.label" :id="field.name" :name="field.name"
                                v-model="field.value" :required="field.required"
                                :rules="field.validation"></v-text-field>
                            <v-select v-else-if="field.type == 'select'" color="primary" item-title="display_name"
                                item-value="id" :label="field.label" :items="field.options" :required="field.required"
                                :rules="field.validation" v-model="field.value" :placeholder="field.placeholder"
                                @update:modelValue="isShowNextButtonDisabled = false">
                            </v-select>
                            <DateTimeField v-else-if="field.type == 'datetime'" :field="field" />
                            <TextAreaField v-else-if="field.type == 'textarea'" :field="field" />
                            <ColorField v-else-if="field.type == 'color'" :field="field" />
                            <CheckboxField v-else-if="field.type == 'checkbox'" :field="field" />
                            <MACField v-else-if="field.type == 'mac'" :field="field" />
                        </div>
                    </div>
                    <v-btn class="w-100" color="primary" :disabled='isShowNextButtonDisabled' @click="validateForm()">
                        {{ next_button_text }}
                    </v-btn>
                </v-form>
            </v-card-text>
            <v-card-actions>
            </v-card-actions>
        </v-card>
    </v-dialog>

</template>

<script setup>
import { ref, computed, watch, onBeforeMount } from 'vue'
import TextAreaField from '@/components/admin/forms/fields/GeneralTextAreaField'
import DateTimeField from '@/components/admin/forms/fields/GeneralDateTimeField'
import ColorField from '@/components/admin/forms/fields/GeneralColorField'
import CheckboxField from '@/components/admin/forms/fields/GeneralCheckboxField'
import MACField from '@/components/admin/forms/fields/MACField'
import { formConfigurations } from '@/config/formData'

const props = defineProps({
    type: String,
    data: Object,
    isActiveDialog: Boolean
})

const emit = defineEmits(["update:isActiveDialog", "close", "formComplete"])

const form = ref(null)
const isShowNextButtonDisabled = ref(true)
const next_button_text = ref('Siguiente')
const showBackArrow = ref(false)
const currentPage = ref(1)
const loading = ref(false)
const formData = ref([])

onBeforeMount(() => {
    currentPage.value = 1
    isShowNextButtonDisabled.value = true
    showBackArrow.value = false
    if (formConfigurations[props.type]) {
        formData.value = formConfigurations[props.type](props.data);

    } else {
        formData.value = [{ title: "Error al cargar el modal" }]
    }
})


const validateForm = async () => {
    const valid = await form.value.validate()
    if (valid.valid) {
        let res_data = {}

        formData.value[0].fields.forEach(field => {
            res_data[field.name] = field.value
        })

        if (props.data) res_data.id = props.data.id
        loading.value = true
        emit('formComplete', res_data)
    }
}
</script>
